module.exports = __webpack_public_path__ + "static/media/twitter-logo-silhouette.5d4795c2.svg";